import { Overlay } from '@angular/cdk/overlay';
import { NgClass, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation, inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MAT_AUTOCOMPLETE_SCROLL_STRATEGY, MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { NavigationEnd, Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations/public-api';
import { Subject, filter, map, takeUntil } from 'rxjs';

import { AuthUtils } from 'app/core/auth/auth.utils';

@Component({
    selector     : 'add-new',
    templateUrl  : './add-new.component.html',
    encapsulation: ViewEncapsulation.None,
    exportAs     : 'add-new',
    animations   : fuseAnimations,
    standalone   : true,
    imports      : [NgIf, MatButtonModule, MatIconModule, FormsModule, MatAutocompleteModule, ReactiveFormsModule, MatOptionModule, NgFor, RouterLink, NgTemplateOutlet, MatFormFieldModule, MatInputModule, NgClass],
    providers    : [
        {
            provide   : MAT_AUTOCOMPLETE_SCROLL_STRATEGY,
            useFactory: () =>
            {
                const overlay = inject(Overlay);
                return () => overlay.scrollStrategies.block();
            },
        },
    ],
})
export class AddNewComponent implements OnInit, OnDestroy
{
    protected planLevel: string = 'A';

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    protected addNewText = '';
    protected addNewVisible: boolean = false;
    protected addNewFunc = () => { };

    constructor(
        private _router: Router,        
    )
    {
        this.setContext();

        this.planLevel = AuthUtils.user.planLevel;

        _router.events
            .pipe(
                takeUntil(this._unsubscribeAll), 
                filter((event) => event instanceof NavigationEnd),
                map((event: NavigationEnd) => this.setContext()
            )
         )
        .subscribe();             
    }

    ngOnInit(): void
    {
    }

    ngOnDestroy(): void
    {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    setContext() {
        switch (true) {
            case window.location.pathname.indexOf(`/calendar`) > -1:
            case window.location.pathname.indexOf(`/my-week`) > -1:                   
            case window.location.pathname.indexOf(`/my-team`) > -1:                            
            case window.location.pathname.indexOf(`/map`) > -1:                            
            case window.location.pathname.indexOf(`/people`) > -1:                            
                this.addNewVisible = true;
                this.addNewText = 'New Booking';
                this.addNewFunc = () => {
                    // Clear New Booking session keys when clicking on Add New button
                    delete sessionStorage._selected_assetTypeId;
                    delete sessionStorage._selected_assetTypeName;
                    delete sessionStorage._selected_bookingDateLocal;
                    delete sessionStorage._selected_bookingDateLocalLabel;
                    delete sessionStorage._selected_bookingDateUntilLocal;
                    delete sessionStorage._selected_where;
                    delete sessionStorage._selected_when;
                    delete sessionStorage._selected_when_text;
                    delete sessionStorage._selected_when_text_short;
                    delete sessionStorage._selected_manual_start;
                    delete sessionStorage._selected_manual_end;
                    delete sessionStorage._init_new_booking;

                    this._router.navigate(['new-booking']);
                };
                break;

            default:
                this.addNewVisible = false;
                this.addNewText = '';
                this.addNewFunc = () => {
                };
        }        
    }
}
